import React, { useState, useEffect } from "react";
import M from "materialize-css";
import FixturesTable from "./FixturesTable";

const Fixtures = () => {
  const [data, setData] = useState([]);

  M.AutoInit();

  useEffect(() => {
    fetch(
      `https://sheets.googleapis.com/v4/spreadsheets/1hNFiiQAnBOa6oYC2MR7wXKv9iqE3DFkUNnFPzDJ16EE/values:batchGet?ranges=LEAGUE TABLES&majorDimension=ROWS&key=${process.env.REACT_APP_API_KEY}`
    )
      .then((res) => res.json())
      .then((res) => {
        const rows = res.valueRanges[0].values;
        setData({
          div1: rows.slice(0, 8),
          div2: rows.slice(8, 15),
          div3: rows.slice(15, 23),
          div4: rows.slice(23, 31),
        });
      });
  }, []);

  const tabs = (
    <ul className="tabs col">
      <li className="tab col">
        <a href="#div1">Division 1</a>
      </li>
      <li className="tab col">
        <a href="#div2">Division 2</a>
      </li>
      <li className="tab col">
        <a href="#div3">Division 3</a>
      </li>
      <li className="tab col">
        <a href="#div4">Division 4</a>
      </li>
    </ul>
  );
  const fixtures = (
    <div>
      <div id="div1" className="col s12">
        <FixturesTable data={data.div1} />
      </div>
      <div id="div2" className="col s12">
        <FixturesTable data={data.div2} />
      </div>
      <div id="div3" className="col s12">
        <FixturesTable data={data.div3} />
      </div>
      <div id="div4" className="col s12">
        <FixturesTable data={data.div4} />
      </div>
    </div>
  );

  return (
    <div className="fixtures">
      <div className="row">
        {tabs} {fixtures}
      </div>
    </div>
  );
};

export default Fixtures;
